module.exports = __webpack_public_path__ + "static/Moody1-c45f1264ebda7b9744f4fef577becba3.png";